/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum WoundsImagesListAliases {
  BUTTON_ADD_WOUNDS_IMAGE_LIST = 'button-add-wounds-image-list',
  CONTEXTUAL_WOUNDS_IMAGE_LIST = 'contextual-wounds-image-list',
  FETCH_WOUNDS_IMAGE_LIST = 'fetch-wounds-image-list',
  GALLERY_WOUNDS_IMAGE_LIST = 'gallery-wounds-image-list',
  GLOBAL_ACTIONS_WOUNDS_IMAGE_LIST = 'global-actions-wounds-image-list',
  LAYOUT_WOUNDS_IMAGE_LIST = 'layout-wounds-image-list',
  LOADER_WOUNDS_IMAGE_LIST = 'loader-wounds-image-list',
  MAPPER_WOUNDS_IMAGE_LIST = 'mapper-wounds-image-list',
  PAGINATOR_WOUNDS_IMAGE_LIST = 'paginator-wounds-image-list',
  PANEL_BUTTON = 'panel-button',
  PANEL_FETCH_WOUNDS_IMAGE_LIST = 'panel-fetch-wounds-image-list',
  PANEL_LOADER = 'panel-loader',
}
export { WoundsImagesListAliases };
